"use client";

import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { deleteNotice, noticeList } from "../../api";

export default function NoticePage() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await noticeList({ page, size });
      setList(res.data.items || []);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const handleDelete = async (id) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    try {
      await deleteNotice({ id });
      fetchList();
    } catch (e) {
      alert("삭제 실패");
    }
  };

  return (
    <Box>
      <Flex justify="space-between" align="center" mb="20px">
        <Text fontSize="20px" fontWeight="bold">
          공지사항 관리
        </Text>
        <Button colorScheme="blue" onClick={() => navigate("/notices/new")}>
          공지 작성
        </Button>
      </Flex>

      {loading ? (
        <Spinner />
      ) : (
        <Table bg="white">
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>제목</Th>
              <Th>등록일</Th>
              <Th>관리</Th>
            </Tr>
          </Thead>
          <Tbody>
            {list.map((item) => (
              <Tr key={item.noticeId}>
                <Td>{item.noticeId}</Td>
                <Td
                  cursor="pointer"
                  onClick={() => navigate(`/notices/${item.noticeId}`)}
                >
                  {item.title}
                </Td>
                <Td>{item.createdAt?.slice(0, 10)}</Td>
                <Td>
                  <Button
                    size="sm"
                    mr="6px"
                    onClick={() => navigate(`/notices/${item.noticeId}/edit`)}
                  >
                    수정
                  </Button>
                  <Button
                    size="sm"
                    colorScheme="red"
                    onClick={() => handleDelete(item.noticeId)}
                  >
                    삭제
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}

      <Flex justify="center" mt="16px" gap="12px">
        <Button isDisabled={page === 0} onClick={() => setPage(page - 1)}>
          이전
        </Button>
        <Button onClick={() => setPage(page + 1)}>다음</Button>
      </Flex>
    </Box>
  );
}
